<template>
  <!-- 复制弹窗 -->
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('Message.SelectCopyContent')"
    width="400px"
    :close-on-click-modal="false"
  >
    <div>
      <fieldset>
        <legend>{{ $t('Message.CopyContent') }}</legend>
        <div style="display: flex;flex-direction: column;padding-left: 30px;">
          <el-checkbox v-model="basicInfo" :disabled="true">{{ lob === 'AI' && isMaster ? $t('SeaExport.MblInfo') : $t('SeaExport.BasicInfo') }}</el-checkbox>
          <!--CARGO-734空运订舱复制弹框调整 qm 19/12/3-->
          <!--①空出(空运订舱 AE 删除订舱 预配信息 改MAWB HAWB) ②空进(空运操作 AI 删除订舱 删除预配 HBL MBL)  ③海进(海运操作 SI 删除订舱 删除预配) ④海出(海运订舱极速版 不变)-->
          <el-checkbox v-show="lob === 'SE'" v-model="booking">{{ $t('SeaExport.Booking') }}</el-checkbox>
          <el-checkbox v-show="!isMaster && lob === 'SE'" v-model="prePlanBooking">{{ $t('SeaExport.prePlanBooking') }}</el-checkbox>
          <el-checkbox v-show="lob === 'SE' || lob === 'SI' || lob === 'AE'" v-model="mbl" :disabled="mblEnable">{{ lob === 'AE' ? 'MAWB' : 'MBL' }}</el-checkbox>
          <el-checkbox v-show="!isMaster && (lob === 'SE' || lob === 'SI' || lob === 'AE')" v-model="hbl" :disabled="hblEnable">{{ lob === 'AE' ? 'HAWB' : 'HBL' }}</el-checkbox>
          <el-checkbox v-model="charge">{{ $t('SeaExport.Charge') }}</el-checkbox>
          <el-checkbox v-show="lob === 'IE' && containerLoadType === 'TT'" v-model="truckingInfo">{{ $t('SeaExport.GatheringTrailer') }}</el-checkbox>
        </div>
      </fieldset>
      <div v-if="lob==='SE'||lob==='SI'||lob==='AE'||lob==='AI'||lob==='RE'||lob==='RI'||lob==='IE'||lob==='remoteBooking'" style="display: flex; flex-direction: row;align-items: center">
        <el-checkbox v-model="notMatchAgainSelect" style="margin-top: 8px;margin-bottom: 8px;word-wrap: break-word;white-space: normal;word-break:normal;display: flex;flex-direction: row;justify-content: center">
          <span style="font-size: 12px">{{ $t('queryJob.WhenDepartmentBranchNewSelection') }}</span>
        </el-checkbox>
      </div>
      <div style="display: flex; flex-direction: row;align-items: center">
        <el-checkbox v-model="rmb" style="margin-top: 8px;margin-bottom: 8px;word-wrap: break-word;white-space: normal;word-break:normal;display: flex;flex-direction: row;justify-content: center">
          <span style="font-size: 12px">{{ $t('SeaExport.ByThisTimeAfterSelectingTheCopiedWithoutHavingToAskLeft') }}</span>
        </el-checkbox>
      </div>
      <div style="word-wrap: break-word; white-space: normal;font-family: sans-serif;margin-bottom: 8px;margin-left: 24px">
        <span style="font-size: 10px;color: #8c939d;line-height: 18px">{{ $t('SeaExport.ByThisTimeAfterSelectingTheCopiedWithoutHavingToAskRight') }}</span>
      </div>
      <div v-show="showCopyNumber && (lob === 'SE' || lob==='AI' || 'AE' || 'SI')" style="margin-left: 24px;font-size: 12px;-webkit-font-smoothing: antialiased;text-rendering: optimizeLegibility;font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;">
        <label>{{ $t('Message.CopyNumber') }}</label>
        <el-input-number :value="copyNum" :precision="0" :min="1" :max="100" controls-position="right" style="width: 100px;" @input="numFunction" />
      </div>
    </div>
    <span slot="footer">
      <el-button no="confirm" type="primary" @click="enterHandler">{{ $t('common.btn.confirm') }}</el-button>
      <el-button no="cancel" @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

import LocalStorageUtils from '@/utils/localStorageUtils'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'

export default {
  name: 'JobCopyWindow',
  components: { },
  props: {
    visible: { type: Boolean, required: true },
    showCopyNumber: { type: Boolean, required: false, default: true },
    lob: { type: String, default: '' },
    containerLoadType: { type: String, required: false, default: '' },
    isMaster: { type: Boolean, default: false } // 是否为主票
  },
  data() {
    return {
      innerVisible: false,
      basicInfo: true,
      booking: false,
      prePlanBooking: false,
      mbl: false,
      hbl: false,
      charge: false,
      truckingInfo: false,
      notMatchAgainSelect: false, // 当业务的销售/单证/客服人员所在部门或分公司与原单据不一致时，需要重新选择
      rmb: false, // 以后是否显示此弹框
      copyNum: 1,
      mblEnable: false,
      hblEnable: false
    }
  },
  computed: {
    // 缓存后缀
    cacheSuffix() {
      return this.isMaster ? this.lob + '_MASTER' : this.lob
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.init()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.init()
    }
  },
  methods: {
    init() {
      if (this.lob) {
        this.mblEnable = this.lob === 'AI'
        this.hblEnable = this.mblEnable
      }
      this.notMatchAgainSelect = false
      this.rmb = false
      this.mbl = LocalStorageUtils.getConfiguration('COPY_MBL_' + this.cacheSuffix) === '' ? false : LocalStorageUtils.getConfiguration('DEF_COPY_MBL_' + this.cacheSuffix)
      this.hbl = LocalStorageUtils.getConfiguration('COPY_HBL_' + this.cacheSuffix) === '' ? false : LocalStorageUtils.getConfiguration('DEF_COPY_HBL_' + this.cacheSuffix)
      this.charge = LocalStorageUtils.getConfiguration('COPY_CHARGE_' + this.cacheSuffix) === '' ? false : LocalStorageUtils.getConfiguration('DEF_COPY_CHARGE_' + this.cacheSuffix)
      this.truckingInfo = LocalStorageUtils.getConfiguration('COPY_TRUCK_INFO_' + this.cacheSuffix) === '' ? false : LocalStorageUtils.getConfiguration('DEF_TRUCK_INFO_' + this.cacheSuffix)
      this.booking = LocalStorageUtils.getConfiguration('COPY_VESSEL_EQ_' + this.cacheSuffix) === '' ? false : LocalStorageUtils.getConfiguration('DEF_COPY_VESSEL_EQ_' + this.cacheSuffix)
      this.prePlanBooking = LocalStorageUtils.getConfiguration('COPY_PRE_PLAN_BOOKING_' + this.cacheSuffix) === '' ? false : LocalStorageUtils.getConfiguration('DEF_COPY_PRE_PLAN_BOOKING_' + this.cacheSuffix)
      this.copyNum = LocalStorageUtils.getConfiguration('COPY_NUM_INPUT' + this.cacheSuffix) === '' ? 1 : LocalStorageUtils.getConfiguration('DEF_COPY_NUM_INPUT' + this.cacheSuffix)
    },
    enterHandler() {
      LocalStorageUtilsNew.setConfiguration('NOT_MATCH_AGAIN_SELECT_' + this.cacheSuffix, this.notMatchAgainSelect)
      LocalStorageUtils.setConfiguration('COPY_JOB_' + this.cacheSuffix, this.rmb)
      const isImport = (this.lob === 'AI')
      LocalStorageUtils.setConfiguration('COPY_VESSEL_EQ_' + this.cacheSuffix, this.booking)
      LocalStorageUtils.setConfiguration('COPY_MBL_' + this.cacheSuffix, isImport ? false : this.mbl)
      LocalStorageUtils.setConfiguration('COPY_HBL_' + this.cacheSuffix, isImport ? false : this.hbl)
      LocalStorageUtils.setConfiguration('COPY_CHARGE_' + this.cacheSuffix, this.charge)
      LocalStorageUtils.setConfiguration('COPY_PRE_PLAN_BOOKING_' + this.cacheSuffix, this.prePlanBooking)
      LocalStorageUtils.setConfiguration('COPY_NUMBERS_' + this.cacheSuffix, '1')
      if (this.lob === 'IE') {
        LocalStorageUtils.setConfiguration('COPY_TRUCK_INFO_' + this.cacheSuffix, this.truckingInfo)
      }
      // 复制业务的标识
      LocalStorageUtils.setConfiguration('COPY_JOB', true)
      LocalStorageUtils.setConfiguration('COPY_NUM_INPUT' + this.cacheSuffix, this.copyNum.toString())
      // 勾选不再弹出则设置默认值
      if (this.rmb) {
        this.setDefaultValue()
      }
      this.confirmCallBack()
      this.close()
    },
    setDefaultValue() {
      const isImport = (this.lob === 'AI')
      LocalStorageUtils.setConfiguration('DEF_COPY_VESSEL_EQ_' + this.cacheSuffix, this.booking)
      LocalStorageUtils.setConfiguration('DEF_COPY_MBL_' + this.cacheSuffix, isImport ? false : this.mbl)
      LocalStorageUtils.setConfiguration('DEF_COPY_HBL_' + this.cacheSuffix, isImport ? false : this.hbl)
      LocalStorageUtils.setConfiguration('DEF_COPY_CHARGE_' + this.cacheSuffix, this.charge)
      LocalStorageUtils.setConfiguration('DEF_COPY_PRE_PLAN_BOOKING_' + this.cacheSuffix, this.prePlanBooking)
      LocalStorageUtils.setConfiguration('DEF_COPY_NUMBERS_' + this.cacheSuffix, '1')
    },
    confirmCallBack() {
      this.$emit('confirmCallBack')
    },
    numFunction(val) {
      if (typeof val === 'undefined') {
        this.copyNum = NaN
        this.$nextTick(function() {
          this.copyNum = 1
        })
      } else {
        this.copyNum = val
      }
    },
    close() {
      this.innerVisible = false
    }
  }
}
</script>

<style>
</style>
